import React, { useState } from "react";
import { Button, Menu, MenuItem, Dialog } from "@mui/material";
import {
  RiLoopRightLine,
  RiDeleteBinLine,
  RiAddCircleLine,
} from "@remixicon/react";

import { DialogTypeT, DialogTypesT } from "../../types/ScheduleForm";
import DeliveriesDialog from "./Dialogs/DeliveriesDialog";
import RecurringDialog from "./Dialogs/RecurringDialog";
import { RecurringRemoveDialog } from "./Dialogs/RecurringRemoveDialog";

import { useDialog } from "../../hooks/useDialog";

export default function ScheduleMenu() {
  const { isOpen, dialogType, openDialog, closeDialog } = useDialog();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleOpenDialog = (type: DialogTypeT) => {
    openDialog(type);
    handleCloseMenu();
  };

  const renderDialogContent = () => {
    switch (dialogType) {
      case DialogTypesT.ADD:
        return <DeliveriesDialog onClose={closeDialog} />;
      case DialogTypesT.RECURRING:
        return <RecurringDialog onClose={closeDialog} />;
      case DialogTypesT.REMOVE_RECURRING:
        return <RecurringRemoveDialog onClose={closeDialog} />;
      default:
        return null;
    }
  };

  return (
    <>
      <Button
        aria-controls="delivery-menu"
        aria-haspopup="true"
        onClick={handleOpenMenu}
        variant="contained"
      >
        Manage
      </Button>
      <Menu
        id="delivery-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
      >
        <MenuItem onClick={() => handleOpenDialog(DialogTypesT.ADD)}>
          <RiAddCircleLine size={20} style={{ marginRight: "8px" }} /> Add
          Delivery
        </MenuItem>
        <MenuItem onClick={() => handleOpenDialog(DialogTypesT.RECURRING)}>
          <RiLoopRightLine size={20} style={{ marginRight: "8px" }} />
          Add Recurring
        </MenuItem>
        <MenuItem
          onClick={() => handleOpenDialog(DialogTypesT.REMOVE_RECURRING)}
        >
          <RiDeleteBinLine size={20} style={{ marginRight: "8px" }} />
          Remove Recurring
        </MenuItem>
      </Menu>
      <Dialog open={isOpen} onClose={closeDialog} maxWidth="md" fullWidth>
        {renderDialogContent()}
      </Dialog>
    </>
  );
}
